// extracted by mini-css-extract-plugin
export default {"dragger":"ri1Dr","floor":"QXq84","dragging":"mp9S5"};